import Modal from '@src/layouts/Modal';
import Button from '@src/ui/elements/button/Button';
import React from 'react';

export interface ConfirmModalProps {
  isOpen?: boolean;
  title?: string;
  message?: string | React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  confirmDisabled?: boolean;
  onConfirm: () => void;
  onClose: () => void;
  width?: string;
  className?: string;
  isDanger?: boolean;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen = true,
  title = 'まだ保存されていません',
  message = (
    <>
      編集内容が保存されていません。
      <br />
      <span className='whitespace-nowrap sm:whitespace-normal'>
        このまま続行すると編集内容が破棄されますがよろしいですか？
      </span>
    </>
  ),
  confirmText = '編集内容を破棄して閉じる',
  cancelText = '編集を続行',
  confirmDisabled = false,
  onConfirm,
  onClose,
  width = 'clamp(550px, 90vw, 480px)',
  className = '',
  isDanger = false,
}) => {
  return (
    <React.Fragment>
      {isOpen && (
        <div className={`h-[120vh] ${className}`}>
          <Modal width={width}>
            <div className='relative flex grow flex-col gap-8 px-8 py-10'>
              <button
                onClick={onClose}
                className='absolute right-4 top-4 flex size-8 items-center justify-center rounded-full text-black transition-colors hover:bg-gray-100 hover:text-gray-600'
                aria-label='Close modal'
              >
                <svg
                  className='size-5'
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M6 18L18 6M6 6l12 12'
                  />
                </svg>
              </button>

              {title && (
                <div className='border-b border-b-gray-350 pb-4 pr-8'>
                  <h2 className='text-lg font-semibold'>{title}</h2>
                </div>
              )}

              <div className='whitespace-pre-wrap text-left'>
                {typeof message === 'string' ? <p>{message}</p> : message}
              </div>

              <div className='mt-auto flex w-full flex-row justify-center gap-2 sm:flex-col sm:justify-start sm:gap-5'>
                <div className='w-[250px] sm:w-auto'>
                  <Button
                    outline={!isDanger}
                    fullRounded
                    fullWidth
                    variant='secondary'
                    disabled={confirmDisabled}
                    onClick={onConfirm}
                    className={`whitespace-nowrap ${
                      isDanger
                        ? ''
                        : 'transition-colors hover:!border-red-500 hover:!bg-red-500 hover:!text-white'
                    }`}
                  >
                    {confirmText}
                  </Button>
                </div>
                <div className='w-[250px] sm:w-auto'>
                  <Button
                    outline
                    fullRounded
                    fullWidth
                    onClick={onClose}
                    className='whitespace-nowrap'
                  >
                    {cancelText}
                  </Button>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      )}
    </React.Fragment>
  );
};

export default ConfirmModal;
